export const deformateDate = (formattedDate: string) => {
  let dataObjeto

  if (formattedDate.includes('/')) {
    const partesData = formattedDate.split('/')
    const dia = parseInt(partesData[0])
    const mes = parseInt(partesData[1]) - 1
    const ano = parseInt(partesData[2])

    dataObjeto = new Date(ano, mes, dia)
  } else {
    const partesData = formattedDate.split('-')
    const ano = parseInt(partesData[0])
    const mes = parseInt(partesData[1]) - 1
    const dia = parseInt(partesData[2])

    dataObjeto = new Date(ano, mes, dia)
  }

  const dataISO = dataObjeto.toISOString()

  return dataISO
}
